import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Stylesheets/Monthtimeline.css";

import AOS from "aos";

const timelineData = [
  {
    time: "Kick-off",
    icon:"	https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img90355_IMG.png",
    title: "Project Kick-off",
    description: [
      "Trainees start working on a mini project based on their chosen domain.",
      "Encourages application of theoretical knowledge in practical scenarios.",
    ],
    thumbs: [],
    badges: [{ text: "Project Start", color: "primary" }],
  },
  {
    time: "Collaboration",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img93595_IMG.png",
    title: "Individual and Team Collaboration",
    description: [
      "Team-based activities to simulate company project culture.",
      "Emphasis on collaboration, communication, and coordination.",
    ],
    thumbs: [],
    badges: [{ text: "Teamwork", color: "success" }],
  },
  {
    time: "Documentation",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img33781_IMG.png",
    title: "Documentation and Presentation",
    description: [
      "Trainees maintain project documentation as per industry standards.",
      "Midway presentations to showcase progress and receive trainer feedback.",
    ],
    thumbs: [],
    badges: [{ text: "Presentation", color: "warning text-dark" }],
  },
];

const Month4 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <section
      id="monthtimeline"
      className="min-vh-100 position-relative overflow-hidden"
    >
      {/* Background Video */}
      {/* <div className="home-bg">
        <video loop autoPlay muted playsInline>
          <source src={bg_video} />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container text-light position-relative">
        <h1 className="text-center gradient-text mt-5 py-3 fw-bold monthtimeline" style={{fontFamily:"'Merriweather', serif"}}>
          Mini Project (Part 1)
        </h1>
        <div className="timeline">
          {timelineData.map((item, index) => (
            <div className="timeline-row" data-aos="fade-up" key={index}>
              <div
                className="timeline-time text-light fw-bold"
                data-aos="zoom-in-up"
              >
                {item.time}
              </div>
              <div className="timeline-content">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="timeline-icon"
                />
                <h4 style={{color:" rgb(7, 223, 252)"}}>{item.title}</h4>

                {/* Description as <ul> */}
                <ul>
                  {item.description.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>

                <div>
                  {item.badges.map((badge, i) => (
                    <span
                      key={i}
                      className={`badge rounded-pill bg-${badge.color} ${
                        i > 0 ? "ms-1" : ""
                      }`}
                    >
                      {badge.text}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Month4;
